import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';
import Transfer from './Transfer';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';

const TransferNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.TRANSFER,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('TRANSFERS', 'TRANSFERS')}>
        <PanelContent pageTitle="Transferência">
          <Transfer />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default TransferNavigationStack;
